/**
 * 投诉路由模块
 * 包含投诉提交页面
 */

const children = [
  {
    path: 'submit',
    name: 'complaint_submit',
    url: '/complaint/submit',
    meta: { title: '投诉提交', requiresAuth: true },
    component: () => import(/* webpackChunkName: "complaint" */ '@/views/complaint/submit.vue')
  }
];

export default {
  path: '/complaint',
  name: 'complaint',
  meta: { title: '投诉中心' },
  component: () => import('@/layout/user.vue'),
  children: children
};
